/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type WorkspaceChannelPlatform = typeof WorkspaceChannelPlatform[keyof typeof WorkspaceChannelPlatform];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceChannelPlatform = {
  YOUTUBE_SHORTS: 'YOUTUBE_SHORTS',
  TIKTOK: 'TIKTOK',
  INSTAGRAM: 'INSTAGRAM',
} as const;
